export default {
  users: {
    list_of_users: 'Liste des utilisateurs',
    role: 'Rôle',
    number_of_authorized_exhibitors: "Nombre d'exposants autorisés",
    firstname: 'Prénom',
    lastname: 'Nom de famille',
    email: 'E-mail',
    create_a_new_moderator: 'Créer un nouveau modérateur',
    exhibitors: 'Exposants',
    collective: 'Collectif',
    events: 'Evènements',
    password: 'Mot de passe',
    phone: 'Téléphone',
    last_login: 'Last login',
    confirm_remove_user: "Confirmer la suppression de l'utilisateur ?",
    company: 'Entreprise',
    add_company: 'Ajouter une entreprise',
    confirm_remove_product:
      'Si vous désactivez le Hub, les produits ajoutés seront enlevés de celui ci. Validez vous votre choix? Confirmer Annuler',
    copy: 'Copier',
    copy_admin: "Copier l'administrateur",
    copy_admin_description:
      "Créer un nouvel administrateur avec une copie des exposants, modérateurs, de l'entreprise et de la configuration associée. Les évènements ne sont jamais copiés.",
    copy_admin_fields_required: "L'e-mail et le mot de passe sont requis.",
    copy_admin_submit: 'Créer la copie',
    copy_admin_success: 'Administrateur copié avec succès.',
    copy_admin_error: "Échec de la copie de l'administrateur.",
    cancel: 'Annuler',
  },
};
